__turbopack_context__.v({
  "animated": "_3vXhqa_animated",
  "backgroundCircle": "_3vXhqa_backgroundCircle",
  "bar1": "_3vXhqa_bar1",
  "bar2": "_3vXhqa_bar2",
  "bar3": "_3vXhqa_bar3",
  "dt-logo-pulse-1": "_3vXhqa_dt-logo-pulse-1",
  "dt-logo-pulse-2": "_3vXhqa_dt-logo-pulse-2",
  "dt-logo-pulse-3": "_3vXhqa_dt-logo-pulse-3",
  "image": "_3vXhqa_image",
  "logo": "_3vXhqa_logo",
  "withBackground": "_3vXhqa_withBackground",
});
